/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

const files = require.context('!svg-sprite-loader!../../images/ui/icon-sprites', false, /.*\.svg$/);
files.keys().forEach(files);

type Props = {
  className?: string,
  color?: string,
  type?: string,
  size?: string | number,
  image?: string
};

const defaultProps = {
  className: undefined,
  color: undefined,
  size: '1em',
  type: undefined,
  image: undefined
};

const StyledSVG = styled.svg(
  ({ size }) => ({
    display: 'inline-block',
    height: size,
    verticalAlign: 'middle',
    width: size,
    overflow: 'visible'
  }),
  ({ color }) => (color ? { fill: color } : {})
);

const StyledImg = styled.img(
  ({ size }) => ({
    display: 'inline-block',
    height: size,
    verticalAlign: 'middle',
    width: size,
    overflow: 'visible'
  }),
  ({ color }) =>
    color
      ? {
          '& > svg': { fill: color }
        }
      : {}
);

function Icon({ className, color, image, size, type }: Props) {
  return image ? (
    <StyledImg className={className} src={image} size={size} color={color} />
  ) : (
    <StyledSVG className={className} size={size} color={color}>
      <use href={`#${type}`} />
    </StyledSVG>
  );
}

Icon.defaultProps = defaultProps;

export default React.memo(Icon);
